import React, { useState } from "react";
import "./Home.css";
import Hero from "../../components/Hero/Hero";
import Lifestyle from "../../components/Lifestyle/Lifestyle";
import ImageContainer from "../../components/ImageContainer/ImageContainer";


const Home = ({ setNavbarBg }) => {
  return (
    <div>
      
      <Hero setNavbarBg={setNavbarBg} />
      <ImageContainer/>
      <Lifestyle/> 
    </div>
  );
};
export default Home;
